import { Button } from '@iris/ui/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Registers the service worker and, when a new version is waiting, shows "Nouvelle version disponible — Mettre à
 * jour" (T4 §4.7): the tap activates it and reloads. Nothing happens in development (no worker).
 */
export function UpdatePrompt() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  if (!needRefresh) return null;
  return (
    <div
      role="status"
      className="sticky top-0 z-40 flex items-center justify-center gap-3 bg-primary px-4 py-2 text-sm text-primary-foreground"
    >
      <span>{t('update.body')}</span>
      <Button size="sm" variant="secondary" onClick={() => void updateServiceWorker(true)}>
        <RefreshCw aria-hidden className="h-4 w-4" />
        {t('update.action')}
      </Button>
    </div>
  );
}
